import { createInstance, type InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import MultiLoadBackendAdapter, {
  type MultiloadBackendOptions
} from 'i18next-multiload-backend-adapter';
import type { GroupedLocalesModel } from '@r/api/generated/client.schemas.ts';
import { fetchLocalesWithMaintenanceRetry } from '@r/lib/fetch-locales-with-retry.ts';

const missingKeys: { key: string; lngs: readonly string[] }[] = [];

const APP_ID = import.meta.env.VITE_APP_ID;
const options: InitOptions<MultiloadBackendOptions> = {
  missingKeyHandler: (lngs: readonly string[], _ns: string, key: string) => {
    // Check if the key and language combination already exists in the missingKeys array
    const keyExists = missingKeys.some(
      (missingKey) => missingKey.key === key && missingKey.lngs.toString() === lngs.toString()
    );

    if (!keyExists) {
      missingKeys.push({ key, lngs });
    }
  },
  defaultNS: 'translations',
  saveMissing: true,
  load: 'all',
  fallbackLng: 'fr-FR',
  lowerCaseLng: false,
  backend: {
    backend: HttpBackend,
    backendOption: {
      request: (
        _options: object,
        _url: string,
        _payload: object,
        callback: (
          arg0: null,
          arg1: {
            data: GroupedLocalesModel['groupedLocales'] | undefined;
            status: number;
          }
        ) => void
      ) => {
        // Endpoint critique : retries + maintenance si 500 persistant (via triggerServerError)
        fetchLocalesWithMaintenanceRetry(APP_ID)
          .then((data) => {
            callback(null, {
              data: data.groupedLocales,
              status: 200
            });
          })
          .catch((_error) => {
            callback(null, {
              data: undefined,
              status: 500
            });
          });
      }
    }
  },
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: false
  },
  maxRetries: 1
};
const i18n = createInstance();
void i18n
  .use(MultiLoadBackendAdapter)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<MultiloadBackendOptions>(options, (err) => {
    if (err) {
      return false;
    }
  });

export default i18n;
